import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
export var DataListItemCells = function DataListItemCells(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      dataListCells = _a.dataListCells,
      _a$rowid = _a.rowid,
      rowid = _a$rowid === void 0 ? '' : _a$rowid,
      props = __rest(_a, ["className", "dataListCells", "rowid"]);

  return React.createElement("div", Object.assign({
    className: css(styles.dataListItemContent, className)
  }, props), dataListCells);
};